export default __webpack_public_path__ + "static/media/M26.2148eedf.svg";